import { useState,useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useSelector,useDispatch } from 'react-redux';

import LandingPage from './components/LandingPage/LandingPage';
import RoomScenePage from './components/RoomscenePage/RoomscenePage';
import VisualizerPage from './components/VisualizerPage/VisualizerPage';

import LoadingPage from './components/LoadingPage/LoadingPage';
import ChamUpload from './components/ChamUpload/ChamUpload';
import ChamProjects from './components/ChamProjects/ChamProjects';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';

import { visualizerActions } from './store';
import { getAllSheetsFromFile } from './Helpers/SheetsHelper';
import { jsonHelper } from './Helpers/JsonHelper';


const router = createBrowserRouter([
  { path: '/', element: <><LandingPage /> <ChamProjects /></>, errorElement: <><h1>ERROR</h1></> },
  { path: '/shared/:code', element: <LoadingPage/> },
  { path: '/roomscenes', element: <><RoomScenePage />  <ChamProjects /></>  },
  { path: '/visualizer/spec/:specifier/sel/:selString', element: <><VisualizerPage /> <ChamProjects /></>  },
])

function App() {
   const popUpModalActive = useSelector((state) => state.ui.popUpModalActive);
   const [dataReady, setDataReady] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {

    getAllSheetsFromFile('/data/flooringData.xlsx').then(jsonData => {
      dispatch(visualizerActions.setflooringTypes(jsonData.flooringTypes));
    });

    jsonHelper('8552').then((jsonData) => {
      //add series 8552 data globally
      // const data = jsonData.reduce((acc, obj) => {
      //   acc[obj.id] = obj;
      //   return acc;
      // }, {});

      dispatch(visualizerActions.setProductDataBySeries({
        seriesId:8552,
        data:jsonData
      }));

      //add color families 
      let uniqueColorFamilies = {};
      jsonData.forEach((obj) => {
        uniqueColorFamilies[obj.style] = obj;
      });
    
      const flooringColorsArray = Object.values(uniqueColorFamilies);
      dispatch(visualizerActions.setflooringColors(flooringColorsArray));

    });

  }, [dispatch]);

  return (
    <div className={`App ${ popUpModalActive ? 'blur' : ''}`} >
      <RouterProvider router={router} />
      <ChamUpload />
      <LoadingScreen />
    </div>
  );
}

export default App;


